import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import swal from 'sweetalert2';
import { ContactsDTO, EndUserContactInfoDTO, InvitesDTO, MyContactsDTO, RequestsDTO, MyGroupsDTO, GroupContactsDTO } from '../Models/Contact.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';


@Component({
  selector: 'app-manage-contact',
  templateUrl: './manage-contact.component.html',
  styleUrls: ['./manage-contact.component.scss'],
  providers: [SrubUpService]
})

export class ManageContactComponent implements OnInit {

  groupName: string;
  showAddContactDiv: boolean;
  showCreateGroupDiv: boolean;

  addToContactUserIds: Array<number>;

  addToGroupUserIds: Array<number>;

  loginUserId: number;
  acceptedUserId: number;
  deniedUserId: number;
  toDeleteUserId: number;
  toDeleteGroupId: string;
  awaitingApprovalCount: number;

  public loading = false;
  searchUser: string;
  searchUsertxt: string;

  searchvisi: number;
  invite: number;
  inviteemail: string;
  storeindex: number;

  contacts: ContactsDTO;
  myContactsList: Array<MyContactsDTO>;
  contactListForGroup: Array<GroupContactsDTO>;
  sentInvitionList: Array<InvitesDTO>;
  receivedRequestList: Array<RequestsDTO>;
  myGroupsList: Array<MyGroupsDTO>;
  searchUserDetails: Array<EndUserContactInfoDTO>;
  searchUserDetailMapped: EndUserContactInfoDTO;
  searchUserDetailsMapped: Array<EndUserContactInfoDTO>;
  isImpersonateMode: boolean;
  constructor(private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }

    this.isImpersonateMode = Globals.ImpersonationValue;
    this.loginUserId = this.appUserDetails.UserId;
    this.searchvisi = 0;
    this.invite = 0;
    this.storeindex = -1;
    this.contacts = new ContactsDTO();
    this.myContactsList = new Array<MyContactsDTO>();
    this.contactListForGroup = new Array<GroupContactsDTO>();
    this.sentInvitionList = new Array<InvitesDTO>();
    this.receivedRequestList = new Array<RequestsDTO>();
    this.myGroupsList = new Array<MyGroupsDTO>();
    this.searchUserDetails = new Array<EndUserContactInfoDTO>();
    this.searchUserDetailsMapped = new Array<EndUserContactInfoDTO>();

    this.showAddContactDiv = false;
    this.showCreateGroupDiv = false;
    this.groupName = "";
  }

  closesearchcontents() {
    this.searchvisi = 0;
    this.showAddContactDiv = false;
    this.showCreateGroupDiv = false;
  }

  AddContactSelected() {
    this.showAddContactDiv = true;
    this.showCreateGroupDiv = false;
  }

  CreateGroupSelected() {
    this.showAddContactDiv = false;
    this.showCreateGroupDiv = true;
  }

  CreateGroup() {
    if (this.groupName == "") return;
    this.addToGroupUserIds = new Array<number>();
    for (let index = 0; index < this.contactListForGroup.length; index++) {
      if (this.contactListForGroup[index].IsChecked) {
        this.addToGroupUserIds.push(this.contactListForGroup[index].UserId);
      }
    }
    this.loading = true;
    this.scrubUpService.CreateContactsGroup(this.token, this.addToGroupUserIds, this.groupName, this.loginUserId).subscribe(x => {
      if (x != null && x != undefined) {
        swal({
          title: 'Group Created',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

        this.GetContactsInfo();
        this.closesearchcontents();

      }
      else {

      }
      this.loading = false;
    });

  }

  GetContactsInfo() {
    this.contactListForGroup = [];
    this.loading = true;
    this.scrubUpService.GetContactsInfo(this.token, this.loginUserId).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.myContactsList = x['Data'];
        // if (x.MyContacts != null && x.MyContacts != undefined) {
        //   this.myContactsList = this.contacts.MyContacts;
          // this.myContactsList.forEach(element => {

            // if (element.IsGroup != "true") {
            //   let groupContact: GroupContactsDTO;
            //   groupContact = new GroupContactsDTO;
            //   groupContact.UserId = element.UserId;
            //   groupContact.Name = element.Name;
            //   groupContact.Email = element.Email;
            //   groupContact.MobileNumber = element.MobileNumber;
            //   groupContact.IsGroup = element.IsGroup;
            //   groupContact.ContactsGroup = element.ContactsGroup;
            //   groupContact.IsChecked = false;

            //   this.contactListForGroup.push(groupContact);
            // }
          // });
        //}
        // if (x.Invites != null && x.Invites != undefined) {
        //   this.sentInvitionList = this.contacts.Invites;
        // }
        // if (x.Requests != null && x.Requests != undefined) {
        //   this.receivedRequestList = this.contacts.Requests;
        //   this.awaitingApprovalCount = this.receivedRequestList.filter(x => x.RequestStatus == 1).length;
        // }
        // if (x.MyGroups != null && x.MyGroups != undefined) {
        //   this.myGroupsList = this.contacts.Groups;
        // }
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  GetSearchUsersContactInfo() {
    this.searchUserDetails = [];
    this.loading = true;
    this.scrubUpService.GetSearchUsersContactInfo(this.token, this.loginUserId, this.searchUser).subscribe(x => {
      if (x != null && x != undefined) {
        this.searchUserDetails = x;
        this.mapAlreadyAddedContacts();
        this.searchvisi = 1;
        this.invite = 0;
        this.searchUsertxt = this.searchUser;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  mapAlreadyAddedContacts() {
    this.searchUserDetailsMapped = [];
    for (let index = 0; index < this.searchUserDetails.length; index++) {
      this.searchUserDetailMapped = new EndUserContactInfoDTO();
      this.searchUserDetailMapped.UserId = this.searchUserDetails[index].UserId;
      this.searchUserDetailMapped.Email = this.searchUserDetails[index].Email;
      this.searchUserDetailMapped.MobileNumber = this.searchUserDetails[index].MobileNumber;
      this.searchUserDetailMapped.Name = this.searchUserDetails[index].Name;
      // this.searchUserDetailMapped.ContactStatus = this.findObjectByKey(this.myContactsList, 'UserId', this.searchUserDetails[index].UserId) != null ? "Added" : this.findObjectByKey(this.sentInvitionList, 'UserId', this.searchUserDetails[index].UserId) != null ? "Pending" : this.findObjectByKey(this.receivedRequestList, 'UserId', this.searchUserDetails[index].UserId) != null ? "Received" : "NotAdded";
      this.searchUserDetailMapped.ContactStatus = this.findObjectByKey(this.sentInvitionList, 'UserId', this.searchUserDetails[index].UserId) != null ? this.findObjectByKey(this.sentInvitionList, 'UserId', this.searchUserDetails[index].UserId).InviteStatus : this.findObjectByKey(this.receivedRequestList, 'UserId', this.searchUserDetails[index].UserId) != null ? this.findObjectByKey(this.receivedRequestList, 'UserId', this.searchUserDetails[index].UserId).RequestStatus : -1;
      this.searchUserDetailMapped.disableAssigned = this.searchUserDetailMapped.IsChecked = this.searchUserDetailMapped.ContactStatus == "Added" ? true : false;
      this.searchUserDetailsMapped.push(this.searchUserDetailMapped);
    }
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }
  SendInviteToAddToContacts() {
    this.addToContactUserIds = new Array<number>();
    for (let index = 0; index < this.searchUserDetailsMapped.length; index++) {
      if (this.searchUserDetailsMapped[index].IsChecked) {
        this.addToContactUserIds[index] = this.searchUserDetailsMapped[index].UserId;
      }
    }
    this.loading = true;
    this.scrubUpService.SendInviteToAddToContacts(this.token, this.addToContactUserIds, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Sent invite to add to your contacts',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

        this.GetContactsInfo();
      }
      else {

      }
      this.loading = false;
    });
  }


  AcceptAddToContactRequest(index: number) {
    this.acceptedUserId = this.receivedRequestList[index].UserId;
    this.loading = true;
    this.scrubUpService.AcceptAddToContactRequest(this.token, this.acceptedUserId, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Contact added.',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

        this.GetContactsInfo();

      }
      else {

      }
      this.loading = false;
    });

  }

  DenyAddToContactRequest(index: number) {
    this.deniedUserId = this.receivedRequestList[index].UserId;
    this.loading = true;
    this.scrubUpService.DenyAddToContactRequest(this.token, this.deniedUserId, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Denied request.',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

        this.GetContactsInfo();

      }
      else {

      }
      this.loading = false;
    });
  }

  opensearchcontents() {
    this.searchvisi = 1;
    this.invite = 0;
  }

  Addcontacts() {
    this.searchvisi = 0;
  }

  DeleteContact(index: number,ContactID:any) {
    if (this.myContactsList[index].IsGroup != "true") {
      this.toDeleteUserId = this.myContactsList[index].UserId;
      this.toDeleteGroupId = "";
    }
    else if (this.myContactsList[index].IsGroup == "true") {
      this.toDeleteUserId = this.myContactsList[index].UserId;
      this.toDeleteGroupId = this.myContactsList[index].ContactsGroup.GroupId;
    }
    this.loading = true;
    this.scrubUpService.DeleteContact(this.token, ContactID, this.toDeleteGroupId, this.loginUserId).subscribe(x => {
      if (x['Status'] == true) {
        swal({
          title: 'contact Deleted.',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

        this.GetContactsInfo();

      }
      else {

      }
      this.loading = false;
    });
  }

  OpenInviteForm() {
    this.invite = 1;
    this.searchvisi = 0;
  }

  SendInvite() {
    //this.inviteemail is used to send the invite link
    this.invite = 0;
  }

  CloseNewUserInvite() {
    this.invite = 0;
  }

  // call(index: number) {
  //   this.storeindex = index;
  // }

  ngOnInit() {
    this.GetContactsInfo();
    //this.GetAllUsersContactInfo();
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/manage-contact/manage-contact.component.ts